export const BUTTON = {
  SHAPE: { CIRCLE: "circle", PILL: "pill", DEFAULT: "default" },
  SIZE: { LARGE: "large", MEDIUM: "medium", SMALL: "small" },
  ACCENT_COLOR: {
    PRIMARY: "primary",
    DANGER: "danger",
    SUCCESS: "success",
    BODY: "body",
  },
  KIND: {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    MINIMAL: "minimal",
    LINK: "link",
  },
};